import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Icon, Badge, Dropdown, Menu, Button,
} from 'antd';

const mapStateToProps = state => ({
    notifications: state.App.App_content.notifications,
    lead_approval: state.Leads.Lead_profile.Lead_general.approval,
    Lead_mot_history: state.Leads.Lead_profile.Lead_mot_history,
});

export default connect(mapStateToProps, null)(class TopbarNotification extends PureComponent {
  clearNotifications = () => this.props.dispatch({ type: 'CLEAR_APP_NOTIFICATIONS' });


  render() {
      const { notifications } = this.props;
      const menu = (
          <Menu style={{ width: 320, padding: 10 }}>
              <Menu.Item>
                  <h3 style={{ textAlign: 'center' }}>Notifications</h3>
                  {notifications.length
                      ? (
                          <Fragment>
                              {notifications.map((item, index) => (
                                  <div key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                                      <span style={{ fontStyle: 'italic', paddingTop: 5 }}>
                                          {index + 1}
                                          .
                                          {' '}
                                          {item.msg}
                                      </span>
                                      <Button type="primary"><Link to="/Leads/Lead_approval">View</Link></Button>
                                  </div>
                              ))}
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                  <Button style={{ marginTop: 25 }} onClick={this.clearNotifications}>Clear</Button>
                              </div>
                          </Fragment>
                      )
                      : <div style={{ textAlign: 'center', fontStyle: 'italic' }}>No notifications</div>
                  }
              </Menu.Item>
          </Menu>
      );

      return null;
  }
});



// WEBPACK FOOTER //
// ./src/modules/App/components/topbar/TopbarNotification.js